export default __webpack_public_path__ + "static/media/26_lady_supreme.0ca78a7b.png";